// extracted by mini-css-extract-plugin
module.exports = {"CowTagNumber":"CowTagNumber--swAC7","Table":"Table--3mNYa","Small":"Small--3tVeb","HighRisk":"HighRisk--ervFT","MediumRisk":"MediumRisk--2YUZm","LowRisk":"LowRisk--1Gly0"};